/**
 * Persistent drawers keep their dialog role while hidden; Reka dialogs either
 * unmount or carry data-state. Scratch is checked through its shared open state.
 */
export function anotherOverlayIsOpen(): boolean {
  for (const el of document.querySelectorAll('[role="dialog"],[role="alertdialog"]')) {
    if (el.closest('[data-scratch-overlay]'))
      continue
    if (el.getAttribute('data-state') === 'closed')
      continue
    if (el.closest('[aria-hidden="true"],[inert]'))
      continue
    return true
  }
  return false
}
